import {Link, useLocation, useParams} from 'react-router-dom';
import React, {useEffect, useState} from "react";
import DOMPurify from 'dompurify';
import {Formik, Form, Field, ErrorMessage, FormikValues, FormikHelpers} from 'formik';
import * as Yup from 'yup'

const SingleBlogger = () =>{
    const [data, setData] = useState([]);
    const [user, setUser] = useState('');
    const {slug} = useParams();
    let location = useLocation();

    useEffect(() => {
        // console.log("loaded " + location.pathname);
            //fetch('http://localhost:10053/?method=bloggers_feed')
        // async function fetchData() {
        //     const result = await fetch( global.config.api + `/?method=get_blogger&slug=${slug}`);
        //     const body = await result.json();
        //     setData(body);
        //     // console.log(body);
        //     // console.log(`/?method=get_blogger&slug=${slug}` + ' - ' + slug);
        // }
        //fetchData();
            fetch( global.config.api + `/?method=get_blogger&slug=${slug}`)
                .then(response => response.json())
                .then(json => {
                    if (json && json.valid) {
                        setData(json);
                        // console.log(json);
                        // console.log(`/?method=get_blogger&slug=${slug}` + ' - ' + slug);
                    } else {
                        console.error('Invalid data structure', json);
                    }
                })
                .catch(error => console.error('Error fetching data:', error));
    }, [slug]);
    // console.log(useParams());

    const commentsFeed = data.comments;
    // console.log(commentsFeed);

    const closeSearchBox = () =>{
        let node = document.getElementById('search_form');
        if (node.classList.contains("search_results")){
            node.classList.remove('search_results');
        }
        //console.log('closeSearchBox ')
    }

    const renderStars = (rating) => {
        ///console.log('loaded');
        const full_stars  = Math.floor( rating );
        const half_stars  = Math.ceil( rating - full_stars ) + full_stars;

        let all_stars = [];
        //console.error( full_stars + ' ' + half_stars + ' ' + empty_stars);
        for (let i = 1; i <= 5; i++) {
            if( full_stars >= i){
                all_stars[i] = 'full';
            } else if ( half_stars >= i ){
                all_stars[i] = 'half';
            } else {
                all_stars[i] = 'empty';
            }
        }
        let rating_float = parseFloat(rating) + 0.001 ;

        // rating.toFixed(1);
        return (<div className="star-rating"><span className="rating-text">{rating_float.toFixed(1)}</span>
                {all_stars.map(star => (
                    <div className={'star star-' + star} aria-hidden="true"></div>
                ))}
            </div>
        );
    }

    const getPostThumbnail = (avatar) => {
        return avatar == '' ? '/wp-content/plugins/blog_tools/images/no_avatar.png' : avatar;
    }

    const getProcentChangeClass = (change) => {
        return change <= 0 ? 'red' : 'green';
    };

    const checkHTML = (string) => {
        return DOMPurify.sanitize(string, { USE_PROFILES: { html: true } });
    }

    const buildComments = (comments) => {

        if(!Array.isArray(comments)) {
            return '';
        } else {
            return (
                <ul className="single_bloger_comments_new_comments">
                    {comments.map( item => (
                        <li className="single_bloger_comments_new_comments_wraper">
                            <div className="single_bloger_comments_new_comments_wraper_header">
                                <div className="single_bloger_comments_new_comments_wraper_header_icon">
                                    <img  src={item.avatar_url} alt={item.comment_author}/>
                                </div>
                                <div className="single_bloger_comments_new_comments_wraper_header_name_date">
                                    <div className="single_bloger_comments_new_comments_wraper_header_name">
                                        {item.comment_author}
                                    </div>
                                    <div className="single_bloger_comments_new_comments_wraper_header_date">
                                        {item.comment_date}
                                    </div>
                                </div>
                            </div>
                            <div className="single_bloger_comments_new_comments_wraper_content" dangerouslySetInnerHTML={{__html: checkHTML(item.comment_content)}}></div>
                        </li>
                        )
                    )
                    }
                </ul>
            );
        }
    }

    const validationSchema = Yup.object().shape({
        user_name: Yup.string(),
        user_email: Yup.string().email('Не корректный емейл').required('Укажите емейл'),
        comment: Yup.string().min(300, 'Комментарий должен быть не меньше 300 символов').required('Напишите комментарий'),
    });


    const CommentForm = () => (
            <Formik
                initialValues={{
                    user_name: '',
                    user_email: '',
                    comment: '',
                }}
                validationSchema={validationSchema}
                // onSubmit={(data) =>{console.log(data)}}
                onSubmit={(values, actions) => {
                    fetch( global.config.api + `/?method=save_comment&slug=${slug}&user_name=${values.user_name}&user_email=${values.user_email}&comment=${values.comment}`)
                        .then(response => response.json())
                        .then(json => {
                            let node = document.getElementById('comment_submit_form');
                            if (json && json.success) {
                                //setData(blogger);
                                node.innerHTML = '<div class="comment_success">Спасибо, Ваш коментарий находится на модерации</div>'
                                // console.log(json.success);
                            } else {
                                node.innerHTML = '<div class="comment_failed">Упс, ошибка данных</div>'
                                console.error('Invalid data structure', json);
                            }
                        })
                        .catch(error => console.error('Error fetching data:', error));
                }}
            >
                {props => (
                    <div id="comment_submit_form">
                    <form onSubmit={props.handleSubmit}>
                        <div className="single_bloger_text_new_comment_name_email">
                            <div className="imput_field_group">
                                {props.errors.user_name && <div className="error">{props.errors.user_name}</div>}
                                <input className="single_bloger_text_new_comment_name"
                                       type="text"
                                       name="user_name"
                                       placeholder="Введите Ваше Имя"
                                       onChange={props.handleChange}
                                       onBlur={props.handleBlur}
                                       value={props.values.user_name}
                                />
                            </div>
                            <div className="imput_field_group">
                                {props.errors.user_email && <div className="error">{props.errors.user_email}</div>}
                                <input className="single_bloger_text_new_comment_email"
                                       type="email"
                                       name="user_email"
                                       placeholder="Введите адрес электронной почты"
                                       onChange={props.handleChange}
                                       onBlur={props.handleBlur}
                                       value={props.values.user_email}
                                />
                            </div>
                        </div>
                        <div>
                            <textarea className="single_bloger_text_new_comment_text"
                                   name="comment"
                                   id="comment"
                                   type="text"
                                   placeholder="Напишите комментарий..."
                                   onChange={props.handleChange}
                                   onBlur={props.handleBlur}
                                   value={props.values.comment}
                            />
                            {props.errors.comment && <div className="error comment_error">{props.errors.comment}</div>}
                        </div>
                        <div className="single_bloger_text_new_comment_buttons">
                            <button type="submit" className="single_bloger_text_new_comment_add">Комментировать</button>
                        </div>
                    </form>
                    </div>
                )}

            </Formik>
    );

    return (
        <div className="single_bloger">
            <div className="container">
                <div className="single_bloger_body">
                    <div className="single_bloger_card">
                        <div className="single_bloger_card_fields">
                            <div className="single_bloger_card_header">
                                <img src={getPostThumbnail(data.avatar)}></img>
                                <div className='coin'>
                                    <div className="single_bloger_title">
                                        {data.user_name}
                                    </div>
                                    {renderStars(data.stars_rating)}
                                </div>
                            </div>
                            <div className='favorite_btn-col'><button className='favorite_btn'></button></div>
                            <div className="single_bloger_stats">
                                <a className="single_bloger_link" href={data.link}>{data.link}</a>
                                <div className="single_bloger_from">
                                    На рынке с {data.on_market_from}
                                </div>
                                <div className="single_bloger_from">
                                    Отзывы ({data.comment_count})
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="single_bloger_text">
                        <div className="single_bloger_text_block" dangerouslySetInnerHTML={{__html: checkHTML(data.body)}}></div>
                        <div className="single_bloger_text_separator"></div>
                        <div className="single_bloger_comments" id="comments" >
                            <div className="single_bloger_text_comments">
                                <div className="single_bloger_text_comments_title">Комментарии</div>
                            </div>
                            <div className="single_bloger_text_new_comment">
                                <img src="/wp-content/plugins/blog_tools/images/avatar.avif" alt="Avatar" className="single_bloger_text_new_comment_avatar"/>
                                {CommentForm()}
                            </div>
                            { buildComments(commentsFeed) }
                        </div>
                    </section>
                </div>
            </div>
        </div>
    )
}

export default SingleBlogger;